import { Box, useMediaQuery, useTheme } from "@mui/material";

const MobileFloatingSpacer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!isMobile) return null;

  return <Box sx={{ height: "90px" }} />; // Adjust height to match floating card
};

export default MobileFloatingSpacer;
